import { useCallback, useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { TOAST_ERROR_IDS } from '../../../interaces/toast.ids.interface';
import { interoperabilityApi } from '../api/interoperability.api';
import { formatDataSearch } from '../../../services/helpers';
import { onClearDataSearch } from '../../../services/hookHelpers';
import { useDataTable } from '../../../hooks/useDataTable';
export const useServices = () => {
  
 const table = useDataTable(interoperabilityApi);

 
  return {
   ...table
  };
};
